<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-account-details</v-icon> Customer Ledger
                    <v-spacer/>
                   
                  
                  </v-toolbar>
                  <v-card-text>
                    <v-row>
                          <v-col cols="12" sm="3" class="text-center">
                                    <v-avatar size="120" >
                                      <img v-if="!IsEmpty(customer.files.profile_picture)" :src="customer.files.profile_picture">
                                      <img v-else :src="$store.state.imgholder" />
                                    </v-avatar>
                          </v-col>
                                  <v-col cols="12" sm="5">
                                      <div class="text-h5 font-weight-bold">{{fullname(customer.profile)}}</div>
                                      <p>
                                        <v-icon small left>mdi-email</v-icon> {{customer.contact.email}}
                                        |
                                        <v-icon small left>mdi-cellphone-basic</v-icon> {{customer.contact.mobile}}
                                        |
                                        <v-icon small left>mdi-phone-classic</v-icon> {{customer.contact.telephone}}
                                    </p>
                                    <p v-if="!IsEmpty(customer.address.billing)">
                                           {{customer.address.billing.line_address}}, {{customer.address.billing.municipality}},
                                           {{customer.address.billing.province}}, {{customer.address.billing.region}}, {{customer.address.billing.country}}, 
                                           {{customer.address.billing.zip}}
                                    </p>
                            </v-col>
                              <v-col cols="12" sm="4">
                                    <p class="mb-1 font-weight-bold" :class="TEXT_COLOR(sales.status)">Contract: {{ sales.status }}</p>
                                    <p class="mb-1">No: {{ sales.id }}</p>
                                     <p class="mb-1">Amount: {{ $money(sales.total_amount) }}</p>

            <table class="va-table va-table-border-bot">
                  <tr>
                    <th>Item</th>
                    <th>Description</th>
                  </tr>
                  <tr  v-for="(item, index) in sales.product_items" :key="index+'-l'">
                   
                    <td><span class="font-weight-bold">({{item.quantity}}x) {{ item.name }}</span>
                        <br/><span class="font-italic def-font text-info" v-if="item.code!='null'">code: {{ item.code }}</span>
                    </td>
                     <td>
                    
                      <p class="ma-1">{{ item.description }}</p>
                        <p class="ma-1 def-font" v-for="(_prop, _index) in item.properties" :key="_index+'-p'">{{_prop.name}} : {{_prop.value}} </p>
                    </td>
                   
                  
                  </tr>
                </table>
                          </v-col>
                           
                    </v-row>
                     <v-row>
                        <v-col cols="4">
                          <v-card>
                              <v-card-text>
                                  <div class="font-weight-bold text-success text-center">TOTAL PAYMENTS: {{$money(TOTALPAYMENT)}}  </div>
                              </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="4">  
                           <v-card>
                              <v-card-text>
                                  <div class="font-weight-bold text-info text-center">BALANCE: {{$money(BALANCE)}}  </div>
                              </v-card-text>
                          </v-card>
                        </v-col>
                          <v-col cols="4">  
                           <v-card>
                              <v-card-text>
                                  <div class="font-weight-bold text-error text-center">OVERDUE BALANCE: {{$money(OVERDUE)}}</div>
                              </v-card-text>
                          </v-card>
                        </v-col>
                     </v-row> 
                    <v-divider class="mt-4"/>

                     <v-tabs v-model="tab">
                        <v-tab>Transactions</v-tab>
                        <v-tab>Payment Schedule</v-tab>
                    </v-tabs>
                     <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                                <table class="va-table va-table-border-bot">
                                      <tr>
                                         <th>No.</th>
                                          <th>Trans. Date</th>
                                          <th>Type</th>
                                         
                                          <th>STATUS</th>
                                          <th class="text-right">Amount</th>
                                      </tr> 
                                      <tr v-for="(item, index) in transactions" :key="index">
                                         <td>{{ item.id }}</td>
                                          <td>{{ $moment(item.created_at).format("YYYY-MM-DD") }}</td>
                                          <td :class="TEXT_COLOR(item.type)">{{ item.type }}</td>
                                         
                                          <td :class="STATUS_BG(item.status)" class="text-center text-white">{{ item.status }}</td>
                                          <td class="text-right">{{ $money(item.total_amount) }}</td>
                                      </tr>
                                  </table>  
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <!-- <div class="pa-4">
                                  <v-btn color="primary"><v-icon left>mdi-credit-card-plus</v-icon> Add Payment</v-btn>
                              </div> -->
                                <table class="va-table va-table-border-bot">
                                      <tr>
                                        <th></th>
                                        <th>Invoice</th>
                                          <th>Due Dates</th>
                                          
                                          <th>Due Amount</th>
                                          
                                          <th>Amount Paid</th>
                                           <th>Balance</th>
                                          <th>Payment Date</th>
                                          <th>Payment Method</th>
                                           <th>Status</th>
                                           <th>Remarks</th>
                                      </tr> 
                                      <tr v-for="(item, index) in payments" :key="index" :class="isDue(item.due_date, item.status)?'bg-warning-light':''">
                                        <td class="text-center"><v-icon color="primary" small v-if="item.status == 'pending'" @click="payment = item,form=true">mdi-credit-card-plus</v-icon></td>
                                        <td>{{item.id}}</td>
                                          <td>{{ $moment(item.due_date).format("MMM DD,  YYYY") }}</td>
                                          
                                          <td>{{ $money(item.amount) }}</td>
                                          
                                          <td>{{ $money(item.paid_amount) }}</td>
                                           <td>{{ $money(item.balance) }}</td>
                                          <td>
                                               <span v-if="!IsEmpty(item.payment_dt)">  {{ $moment(item.payment_dt).format("MMM DD,  YYYY") }} </span>
                                           </td>
                                          <td>{{ item.payment_method}}
                                              <span v-if="!IsEmpty(item.payment_ref)"> - {{ $money(item.payment_ref) }}</span>
                                          </td>
                                           <td :class="TEXT_COLOR(item.status)" class="font-italic">{{ item.status }}</td>
                                           <td>
                                              <span v-if="isDue(item.due_date, item.status)" class="text-error">Over Due</span>
                                            {{ item.remarks }}</td>
                                      </tr>
                                  </table>  
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                   
                  </v-card-text>
                 
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <!-- <va-customer-form :show="form" :selectedID="customer.id" :state="state" @DialogEvent="formEvent" />
         <va-customer-transaction :show="transaction" :customer="customer" @ConfirmEvent="transaction=false" /> -->
         <va-payment-form :show="form" :data="payment" :state="state" @DialogEvent="formEvent" />
          
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           tab: null,
           payment:{},
           transactions: [],
           payments:[],
           search:"",
           sales:{},
           state: 'new',
           user:{profile:{picture:""}},
           customer:{},
           userID:0
,           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
             this.userID= this.$IsNum(this.$route.params.id)
             setTimeout(()=>{this.getCustomer()}, 500)
            
           }
       },
       computed:{
          BALANCE(){
            return this.$IsNum(this.sales.total_amount) - this.TOTALPAYMENT
          },
           OVERDUE(){
            if(this.IsEmpty(this.payments)) { return 0}
            var total = this.payments.reduce((res,item)=>{
              res = res + this.$IsNum(item.balance)
              return res
            },0)
            return total
          },
          TOTALPAYMENT(){
           if(this.IsEmpty(this.payments)) { return 0}
            var total = this.payments.reduce((res,item)=>{
              res = res + this.$IsNum(item.paid_amount)
              return res
            },0)
            return total
          },
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
         isDue(due_date, status){
            var today = this.$moment()
            var _date = this.$moment(due_date)
            var overdue = _date.isBefore(today)
            if(status == 'pending' && overdue) {
                return true
            } return false
           
         },
          fullname(profile){
          if(profile.lastname == "") {
            return profile.firstname
          }
        
          return profile.lastname +', '+ profile.firstname
        },
        statusIndicator(_time) {
          //var current = this.$moment(_time)
          var a = this.$moment()
            var b = this.$moment(_time)
           var diff = a.diff(b, 'hour')
           if(diff <=  3) {
              return 'success'
           } else if(diff > 3 && diff < 5) {
               return '#A5D6A7'
           } else {
             return '#989898'
           }
      },
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getCustomer()
         },
        getTransactions() { 
         
            this.transactions = []
            this.QUERY('vendors',`select * from sales where customer_id=${this.userID} order by id desc`, (res)=>{
                if(res.status) {
                    this.transactions = res.results
                    this.getPayments()
                }
                
            })
        },
        getPayments() { 
           
            this.payments = []
            this.QUERY('vendors',`select * from payment_schedules where customer_id=${this.userID} order by id asc`, (res)=>{
                if(res.status) {
                    this.payments = res.results
                }
                
            })
        },   
        getCustomer() { 
          this.VA_ALERT('info', 'Loading customer data', 'progress', 100, 1500)
           this.customer = {}
            this.QUERY('vendors',`select * from customers where id=${this.userID}`, (res)=>{
              console.log(res)
              if(res.status) {
                  this.customer = res.results[0]
                  this.getTransactions()
                  this.getContract()
              }
              
            })
        },
         getContract() { 
           this.sales = {}
            this.QUERY('vendors',`select * from sales where customer_id=${this.userID} and status='Active'`, (res)=>{
              console.log(res)
              if(res.status) {
                  this.sales = res.results[0]
                
              }
              
            })
        }
       }
     }
   </script>